function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill-rule:evenodd;clip-rule:evenodd;}");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M25.38,57h64.88V37.34H69.59c-2.17,0-5.19-1.17-6.62-2.6c-1.43-1.43-2.3-4.01-2.3-6.17V7.64H8.15 c-0.18,0-0.32,0.09-0.41,0.18C7.59,7.92,7.55,8.05,7.55,8.24v106.45c0,0.14,0.09,0.32,0.18,0.41c0.09,0.14,0.28,0.18,0.41,0.18 l81.51,0c0.18,0,0.17-0.09,0.27-0.18c0.14-0.09,0.33-0.28,0.33-0.41v-11.16H25.38c-4.14,0-7.56-3.4-7.56-7.56V64.55 C17.82,60.4,21.22,57,25.38,57L25.38,57L25.38,57z M50.95,88.6h-8.71l-1.25,4.1h-7.85l9.36-24.88h8.41l9.32,24.88h-8.05L50.95,88.6 L50.95,88.6z M49.32,83.22l-2.72-8.94l-2.73,8.94H49.32L49.32,83.22z M62.7,67.82h12.79c2.79,0,4.87,0.66,6.26,1.99 c1.38,1.33,2.08,3.21,2.08,5.66c0,2.51-0.76,4.48-2.27,5.9c-1.51,1.42-3.82,2.13-6.93,2.13h-4.22v9.21H62.7V67.82L62.7,67.82z M70.41,78.46h1.89c1.49,0,2.54-0.26,3.14-0.78c0.6-0.52,0.9-1.18,0.9-1.98c0-0.78-0.26-1.44-0.79-1.99 c-0.52-0.54-1.51-0.82-2.95-0.82h-2.2V78.46L70.41,78.46z M88.2,67.82h7.71V92.7H88.2V67.82L88.2,67.82z M97.79,57h9.93 c4.16,0,7.56,3.41,7.56,7.56v31.42c0,4.15-3.41,7.56-7.56,7.56h-9.93v13.55c0,1.61-0.64,3.04-1.7,4.1c-1.06,1.06-2.49,1.7-4.1,1.7 l-86.18,0c-1.61,0-3.04-0.65-4.1-1.7c-1.06-1.06-1.7-2.49-1.7-4.1V5.85c0-1.61,0.65-3.04,1.7-4.1c1.06-1.06,2.53-1.7,4.1-1.7h58.72 C64.66,0,64.8,0,64.94,0c0.65,0,1.29,0.28,1.75,0.69h0.09c0.09,0.05,0.14,0.09,0.23,0.18l30,30.36c0.51,0.51,0.88,1.2,0.88,1.98 c0,0.23-0.05,0.41-0.09,0.65L97.79,57L97.79,57L97.79,57z M67.52,27.97V8.94l21.43,21.7H70.19c-0.74,0-1.38-0.32-1.89-0.78 C67.84,29.4,67.52,28.71,67.52,27.97L67.52,27.97z"
}));

function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.28 122.88",
    style: {
      enableBackground: "new 0 0 115.28 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d573ce90.svg";
export { ForwardRef as ReactComponent };